import { Component, Input, OnInit } from '@angular/core';
import { LIST_PERIOD_CONSTANT, PERIOD_CONSTANT } from '@core/constants';
import { CommonHelper } from '@core/services/common';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'caremoni-meal-moisture',
  templateUrl: './meal-moisture.component.html',
  styleUrl: './meal-moisture.component.scss'
})
export class MealMoistureComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() config: any = {};
  moistureList: number[] = [];
  attention_flg: boolean = false;
  attentionFlgList: boolean[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.data && Array.isArray(this.data)) {
      let arrayData: any[] = CommonHelper.getArrayData(cloneDeep(this.data)) || [];
      if (arrayData.length > 0) {
        const currentMealData: any[] = this.getCurrentMealData(arrayData) || [];
        if (currentMealData.length > 0) {
          let periods = LIST_PERIOD_CONSTANT;
          this.attentionFlgList = [];
          periods.forEach(period => {
            let startHour = parseInt(period.START.split(':')[0], 10);
            let endHour = parseInt(period.END.split(':')[0], 10);
            arrayData = CommonHelper.filterLatestByPeriod(arrayData);
            let mealItem = arrayData?.find(item => {
              let hour = new Date(item.date).getHours();
              return hour >= startHour && hour <= endHour;
            });
            this.moistureList.push(mealItem?.moisture ?? '')
            this.attentionFlgList.push(mealItem?.attention_flg);

          });
          this.attention_flg = this.attentionFlgList.some(item => item);
        }
      }
    }
  }

  getCurrentMealData(dataArray: any[]): any[] {
    if (!Array.isArray(dataArray) || dataArray.length === 0) return [];
    let currentMealPeriod: any = null;

    currentMealPeriod = CommonHelper.getCurrentPeriod();
    // Nếu không có khoảng thời gian phù hợp
    if (!currentMealPeriod) return [];

    // Lọc danh sách dữ liệu thuộc khoảng thời gian bữa ăn hiện tại
    return dataArray?.filter(item => {
      const itemHour = new Date(item.date).getHours();
      // giờ bắt đầu luôn luôn là 00:00 sáng của period morning.
      const start = parseInt(PERIOD_CONSTANT.MORNING.START?.split(':')[0], 10);
      // giờ kết thúc theo period hiện tại.
      const end = parseInt(currentMealPeriod.END.split(':')[0], 10);
      return itemHour >= start && itemHour <= end;
    });
  }
}